exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".musteri-karlilik-odeme-report-table[data-v-192f6678]{width:100%;margin-top:4px}.musteri-karlilik-odeme-report-table>*[data-v-192f6678]{width:100%}", ""]);

// exports
